import { render, staticRenderFns } from "./PhotovoltaicModuleFormList.vue?vue&type=template&id=04f3cfea&"
import script from "./PhotovoltaicModuleFormList.vue?vue&type=script&lang=ts&"
export * from "./PhotovoltaicModuleFormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports